module.exports = __webpack_public_path__ + "img/sand-decal-19.6b447371.png";